import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { Stack } from 'office-ui-fabric-react';

import { VehicleProps } from './DetailsInfo.types';
import { Styled } from './DetailsInfo.styles';

import { secureRequest } from 'utils/request';
import { Vehicle } from '../../Video/Video.types';
import { vehicleStrings } from './consts';
import { typeSafeObjectKeys } from './typings';
import combineFullName from 'utils/combineFullName';
import { useSelector } from 'react-redux';
import { IRootState } from 'reducer';
import { ITransportType } from 'reducer/user';
import { useHistory } from 'react-router';
import { useMapHelpers } from 'hooks/useMapHelpers';
import { mapContext } from '../mapContext';
import { latLngsArrayToTuplesArray } from 'utils/map';
import PrimaryButton from 'views/components/UI/PrimaryButton';

export const VehicleDetails: React.FC<VehicleProps> = ({ id }) => {
  const [vehicle, setVehicle] = useState<Vehicle | null>(null);
  const {
    mapRef,
    mapElements,
    setDetailsInfo,
    setFilteredRoutes,
    agenciesFilters,
  } = useContext(mapContext);
  const { centerMap } = useMapHelpers(mapRef);
  const history = useHistory();

  useEffect(() => {
    const request = async () => {
      const info = await secureRequest<Vehicle>('/api/v1/map/online/' + id);
      if (info) {
        setVehicle(info);
      }
    };
    request();
  }, [id]);

  const ttype = useSelector<IRootState, ITransportType | null>(
    (state) =>
      state.user.transporttypes.find((tt) => tt.code === vehicle?.routeType) ||
      null
  );

  if (!vehicle) return null;

  const onSelectRoute = () => {
    const routeId = vehicle.route_id;
    if (routeId) {
      const route = mapElements?.selectedRoutes.find(
        ({ id }) => id === routeId
      );
      if (route) {
        centerMap(latLngsArrayToTuplesArray(route.position));
        setFilteredRoutes([routeId]);
        setDetailsInfo(null);
      }
    }
  };

  const onSelectAgency = () => {
    const agencyName = vehicle.agency;
    const agency = agenciesFilters.agencies.find(
      ({ title }) => title === agencyName
    );
    if (agency) {
      centerMap([agency.ag_lat, agency.ag_lon]);
      setDetailsInfo(null);
    }
  };

  return (
    <Styled.VehicleWrapper>
      {typeSafeObjectKeys(vehicleStrings).map((key) => {
        let data: ReactNode = null;

        switch (key) {
          case 'gosNomer':
          case 'depotNumber':
            data = vehicle[key];
            break;
          case 'driver':
            data = combineFullName({
              first_name: vehicle.driverFirstName,
              middle_name: vehicle.driverMiddleName,
              last_name: vehicle.driverLastName,
            });
            break;
          case 'routeType':
            data = ttype?.title;
            break;
          case 'route':
            data = vehicle[key] ? (
              <PrimaryButton
                onClick={onSelectRoute}
                iconProps={{ iconName: 'mappin' }}
              >
                {vehicle[key]}
              </PrimaryButton>
            ) : null;
            break;
          case 'agency':
            data = (
              <PrimaryButton
                onClick={onSelectAgency}
                iconProps={{ iconName: 'mappin' }}
              >
                {vehicle[key]}
              </PrimaryButton>
            );
            break;
        }

        return (
          <Styled.InfoRow key={key}>
            <Styled.InfoRowTitle>{vehicleStrings[key]}</Styled.InfoRowTitle>
            <Styled.InfoRowData>{data || ' - '}</Styled.InfoRowData>
          </Styled.InfoRow>
        );
      })}
      <PrimaryButton
        iconProps={{ iconName: 'video' }}
        onClick={() => history.push('/video/' + id)}
      >
        Смотреть видео
      </PrimaryButton>
    </Styled.VehicleWrapper>
  );
};
